import { Component, OnInit } from '@angular/core';
import { ApiService } from '@app-services/api.service';
import * as moment from 'moment';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
})
export class FooterComponent implements OnInit {
  currentYear = 2020;
  version = "";
  constructor(private apiService: ApiService) {
    this.currentYear = moment().year();
  }

  ngOnInit(): void {
    this.apiService.getAppConfigs().subscribe((res) => {
      if (res && res.app_version) {
        this.version = res.app_version;
      }
    });
  }
}
